import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams((window.location.hash || "").replace(/^#/, "")).get("session_id");
    if (!sid) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const user = await googleSession(sid);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(user.role === "recruiter" ? "/candidates" : (user.onboarded ? "/tracks" : "/onboarding"), { replace: true });
      } catch {
        setError("Google sign-in failed. Redirecting you to login…");
        setTimeout(() => navigate("/login", { replace: true }), 1600);
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-[#0F172A] flex items-center justify-center px-4" data-testid="auth-callback">
      {error ? (
        <p className="text-slate-300 text-sm">{error}</p>
      ) : (
        <div className="flex items-center gap-3 text-slate-300">
          <Loader2 className="animate-spin text-[#6366F1]" size={20} /> Signing you in…
        </div>
      )}
    </div>
  );
}
